export default __webpack_public_path__ + "static/media/feature-dining.856081b7.svg";